import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_SCRATCH_PLATE_DESIGN_SUMMARY_QUERY = gql`
  query GetScratchPlateDesignSummary($id: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    scratchPlate(id: $id) {
      ... on ScratchPlateNode {
        id
        name
        height
        width
        plateSchema {
          ... on PlateSchemaNode {
            id
          }
          ...InaccessibleInfoGraphQL
        }
        layers {
          name
          dataFrame {
            ... on DataFrameNode {
              id
            }
            ...InaccessibleInfoGraphQL
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
